const dtGenerator   = require ('../../../../../components/dt/dt-generator')
const dtHandler     = require ('../../../../../components/dt/dt-handler')
const dtSearch      = require ('../../../../../components/dt/dt-search')
const inf            = require('../../../../../js-network/inf')
const saleMenu      = require('./sale-menu')
const handler       = require('./sale-fullcont-handler')
const {organizeRow} = require('./sale-dt-handler')
const {tableDetail} = require('./sale-dt-handler')
const {createChart} = require('./chart/sale-chart')

/****************ELEMENTS*****************/
var htmlDt = {}
var HTMLwasSelected = false
const INITIAL_ROWS = 20

function HTMLselect(){ 

      dtHandler.HTMLselect('sale-dt', htmlDt, organizeRow, tableDetail)
      HTMLwasSelected  = true

            
}/**/
/****************ELEMENTS*****************/



export function start(detail){  //console.log('sale-dt 5>', detail)
  
      if(!HTMLwasSelected) { HTMLselect() }
       
      obj[detail.act].start(detail)

}/**/



const obj = {
   
      //From fullcont connection    
      addRow:                 { start: (detail)=>{  dtGenerator.addRow( detail, htmlDt  )           }},
      tableOptions:           { start: (detail)=>{  saleMenu.start(detail, htmlDt, 'htmlFc')        }},
      trMenu:                 { start: (detail)=>{  saleMenu.start(detail, htmlDt, 'htmlFc')        }},
      updateRow:              { start: (detail)=>{  dtGenerator.updateRow(detail, htmlDt)           }},

      //data table
      filter:                 { start: (detail)=>{  dtSearch.filter(detail, htmlDt )                }},
      filterShowHide:         { start: (detail)=>{  dtSearch.filterShowHide(detail, htmlDt )        }},
      loadMore:               { start: (detail)=>{  dtSearch.loadMore(detail, htmlDt )              }},
      searching:              { start: (detail)=>{  dtSearch.searching(detail, htmlDt )             }},
      select:                 { start: (detail)=>{  selectInitial(detail)                            }},
      th:                     { start: (detail)=>{  dtSearch.th(detail, htmlDt )                    }},
      pdfMenudt:              { start: (detail)=>{  handler.pdfMenudt(detail)                       }},
      pdfPackSlipdt:          { start: (detail)=>{  handler.pdfPackSlipdt(detail, htmlDt)           }},

}/**/

function selectInitial(detail) {
      inf.toSelect(detail, htmlDt)
      detail.inf.limit2 = INITIAL_ROWS
      dtSearch.select(detail, htmlDt, true, (result) => {
            htmlDt.footer.setAttribute('data-limit', 10)
            fillChart(result)
      })
      detail.inf.limit2 = 10
}

async function fillChart(result){
      if(!result || !result[0] || !result[0].charts) { return; }
      if(!document.getElementById('chartSale')) { return; }

      const data = JSON.parse(result[0].charts)
      const dataChart = data[0].data

      createChart(dataChart)

}
